module.exports = __webpack_public_path__ + "img/edit-pencil.e3bf903b.svg";